// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"775":"gsap","9508":"ScrollTrigger"}[chunkId] + "." + {"775":"0b1493949f137a320ca6","9508":"ae617d7dd9f7feb8acc6"}[chunkId] + ".js";
};